import React from 'react';

const LoadingOverlay = ({ isLoading, message = 'Chargement des services...' }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-white bg-opacity-95 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="text-center">
        {/* Spinner animé */}
        <div className="relative w-20 h-20 mx-auto mb-6">
          {/* Cercle extérieur */}
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
          {/* Cercle animé */}
          <div className="absolute inset-0 border-4 border-primary-500 rounded-full border-t-transparent animate-spin"></div>
          {/* Point central */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-3 h-3 bg-primary-500 rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Message de chargement */}
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {message}
        </h2>
        <p className="text-sm text-gray-600 animate-pulse">
          Veuillez patienter quelques instants...
        </p>

        {/* Indicateur de progression */}
        <div className="mt-6 w-64 mx-auto">
          <div className="h-1 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-primary-500 to-secondary-400 rounded-full loading-progress"></div>
          </div>
        </div>

        {/* Logo ou icône optionnelle */}
        <div className="mt-8 flex items-center justify-center space-x-2 text-sm text-gray-500">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
          </svg>
          <span>MapataCloud</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
